/**
 * Replace all string characters that are not numbers with an empty string
 * @param {string} value
 */
export const transformToNumbersOnly = (value) => value.replace(/[^0-9]/gi, '');

export const toCamelCase = (str) => {
  return str
    .split('_')
    .map((word, i) => (i === 0 ? word : word.charAt(0).toUpperCase() + word.slice(1)))
    .join('');
};

export const toSentenceCasing = (value = '') => {
  if (typeof value !== 'string') return value;

  const trimmedValue = value.trim();
  if (!trimmedValue) return '';

  return `${trimmedValue.charAt(0).toUpperCase()}${trimmedValue.slice(1).toLowerCase()}`;
};
